module.exports = __webpack_public_path__ + "img/canada-tuberculosis-female.07095adf.png";